import React, { useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db, auth } from "../../firebase";
import { setDoc } from "firebase/firestore";

const RolesSelection = ({ selectedRoles, setSelectedRoles }) => {
  // const handleRoleChange = (role) => {
  //   setSelectedRoles((prevRoles) => {
  //     if (prevRoles.includes(role)) {
  //       return prevRoles.filter((selectedRole) => selectedRole !== role);
  //     } else {
  //       return [...prevRoles, role];
  //     }
  //   });
  // };
  const handleRoleChange = (role) => {
    setSelectedRoles((prevRoles) => {
      // Check if prevRoles is undefined, if so, initialize it with an empty array
      prevRoles = prevRoles || [];
  
      if (prevRoles.includes(role)) {
        // update the role field on the user document
        const user = auth.currentUser;
        const userDoc = doc(db, "users", user.uid);
        setDoc(userDoc, { role: prevRoles.filter((selectedRole) => selectedRole !== role) }, { merge: true });

        return prevRoles.filter((selectedRole) => selectedRole !== role);
      } else {
        return [...prevRoles, role];
      }
    });
  };
  
  
  useEffect(() => {
    const user = auth.currentUser;
    const loadUserData = async () => {
      try {
        const userDoc = doc(db, "users", user.uid);
        
        const userDocRef = await getDoc(userDoc);
        if (userDocRef.exists() && userDocRef.data.role) { 
        setSelectedRoles(userDocRef.data().role[0]);
        console.log(userDocRef.data().role[0]);
        }
      } catch (error) {
        console.error("Error loading user data:", error);
      }
    };

    loadUserData();
  }, [selectedRoles]);

  return (
    <>
      {/* <div className="flex flex-row text-2xl font-semibold mt-6"> Role Selection
      </div> */}

      <div className="flex flex-row text-lg  mt-2">
        <div className="flex items-center mr-4">
          <input
            type="radio"
            value="reader"
            name="roles"
            checked={selectedRoles.includes("Reader")}
            onChange={() => handleRoleChange("Reader")}
            class="w-5 h-5 text-maroon ml-2 bg-maroon border-maroon accent-red focus:ring-maroon dark:focus:ring-maroon dark:ring-offset-maroon focus:ring-2 dark:bg-maroon dark:border-maroon"
          />
          <span className="ml-2">Reader</span>
        </div>

        <div className="flex items-center">
          <input
            type="radio"
            value="author"
            name="roles"
            checked={selectedRoles.includes("Author")}
            onChange={() => handleRoleChange("Author")}
            class="w-5 h-5 text-maroon ml-2 bg-maroon border-maroon focus:ring-maroon dark:focus:ring-maroon dark:ring-offset-maroon focus:ring-2 dark:bg-maroon dark:border-maroon"
          />
          <span className="ml-2">Author</span>
        </div>
      </div>
    </>
  );
};

export default RolesSelection;
